/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online ridgeline / joyplot maker. Paste one column per group to draw stacked, overlapping density curves that show how a distribution changes across groups.`)
};

const es_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de cordillera / joyplot en línea. Pega una columna por grupo para dibujar curvas de densidad apiladas y superpuestas que muestran cómo cambia una distribución entre grupos.`)
};

const de_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Ridgeline-/Joyplot-Generator. Füge eine Spalte pro Gruppe ein, um gestapelte, überlappende Dichtekurven zu zeichnen, die zeigen, wie sich eine Verteilung über Gruppen hinweg verändert.`)
};

const nl_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online ridgeline / joyplot maker. Plak één kolom per groep om gestapelde, overlappende dichtheidscurven te tekenen die laten zien hoe een verdeling verandert tussen groepen.`)
};

const fr_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique en crêtes / joyplot gratuit en ligne. Collez une colonne par groupe pour tracer des courbes de densité empilées et se chevauchant qui montrent comment une distribution évolue selon les groupes.`)
};

const it_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici ridgeline / joyplot online. Incolla una colonna per gruppo per disegnare curve di densità impilate e leggermente sovrapposte che mostrano come cambia una distribuzione tra i gruppi.`)
};

const pt_br2_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de ridgeline / joyplot online. Cole uma coluna por grupo para desenhar curvas de densidade empilhadas e sobrepostas que mostram como uma distribuição muda entre grupos.`)
};

const pt_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos ridgeline / joyplot online. Cole uma coluna por grupo para desenhar curvas de densidade empilhadas e sobrepostas que mostram como uma distribuição muda entre grupos.`)
};

const ja_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンラインリッジライン/ジョイプロット作成ツール。グループごとに1列を貼り付けるだけで、分布がグループ間でどのように変化するかを示す、重なり合った密度曲線を描画します。`)
};

const zh_ridge_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线山脊图 / joyplot 生成器。每组粘贴一列数据，绘制层叠、部分重叠的密度曲线，展示分布如何在各组之间变化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_meta_description", locale)
	if (locale === "en") return en_ridge_meta_description(inputs)
	if (locale === "es") return es_ridge_meta_description(inputs)
	if (locale === "de") return de_ridge_meta_description(inputs)
	if (locale === "nl") return nl_ridge_meta_description(inputs)
	if (locale === "fr") return fr_ridge_meta_description(inputs)
	if (locale === "it") return it_ridge_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_meta_description(inputs)
	if (locale === "pt") return pt_ridge_meta_description(inputs)
	if (locale === "ja") return ja_ridge_meta_description(inputs)
	return zh_ridge_meta_description(inputs)
};